import configService from './config.service';

const getApi = async () => {
    const options = {
        method: 'GET'
    };

    const response = await fetch(`${configService.appConfig.baseApiEndpoint}/External/Map/Key`, options);

    if (!response.ok) {
        const message = `An error occurred: ${response.statusText}`;
        console.error(message);
        return;
    }

    const jsonData = await response.json();
    return jsonData.value;
};

export default {
    getApi
};
